export default {
  default: {
    abort_changes: 'Änderungen abbrechen',
    accept: 'Ich akzeptiere',
    accept_terms: 'Ich bestätige, dass ich volljährig bin und akzeptiere',
    accept_invite: 'Einladung annehmen',
    access_codes: 'Zugangscodes',
    access_edit_profile: 'Profil bearbeiten',
    access_event_search: 'Suche nach Events',
    access_participants_count: '{{text}} Teilnehmende',
    access_press_to_select: 'Doppelklick, um {{type}} zu bearbeiten',
    access_select_sport_level: 'Wähle {{level}}',
    access_selected_sport_level: 'Dein Skill in {{sport}} ist {{level}}',
    account_details: 'Details',
    account_screen: 'Profil',
    account: 'Profil',
    address: 'Adresse',
    add_interests: 'Sportarten hinzufügen',
    admin_panel: 'Admin-Panel',
    add_company: 'Unternehmen hinzufügen',
    add_event: 'Event hinzufügen',
    add_module: 'Modul hinzufügen',
    add_location: 'Location hinzufügen',
    add_participant_club: 'Zum Verein einladen',
    add_participant_team: 'Zum Team einladen',
    add_participants_club_dialog_content:
      'Möchtest Du diese Leute zu deinem Verein einladen',
    add_participants_club_dialog_title: 'Einladung zum Verein',
    add_participants_team_dialog_content:
      'Möchtest Du diese Leute zu deinem Team einladen',
    add_participants_team_dialog_title: 'Einladung zum Team',
    add_to_calendar: 'Zum Kalender hinzufügen',
    admin_dashboard: 'Admin Dashboard',
    advanced_search_screen: 'Erweiterte Suche',
    age_from: 'Ab',
    age_upTo: 'Bis',
    age_years: 'Jahre',
    age: 'Alter',
    ageGroup_adult20: 'Erwachsene Ü20',
    ageGroup_adult35: 'Erwachsene Ü35',
    ageGroup_all: 'Alle Altersgruppen',
    ageGroup_baby: 'Babies & Kleinkinder',
    ageGroup_child: 'Kinder',
    ageGroup_schoolchild: 'Schulkind',
    ageGroup_senior: 'Senioren',
    ageGroup_teen: 'Junior',
    ageGroups: 'Altersgruppe',
    ageGroups_multi: 'Altergruppen',
    all_ages: 'Jedes Alter',
    all_chats: 'Alle Chats sehen',
    all_clubs: 'Alle Vereine',
    all_companies: 'Alle Unternehmen',
    all_days: 'Alle Wochentage',
    all_events: 'Alle Events',
    all_gender: 'Alle Geschlechter',
    all_groups: 'Alle Teams',
    all_sports: 'Alle Sportarten',
    allEvents: 'Alle Events',
    Apple_sign_in: 'Mit Apple anmelden',
    apply_filter: 'Filter anwenden',
    as_agreed: 'wie vereinbart',
    at: 'um',
    authentication_required:
      'Diese Seite ist nur für angemeldete Benutzer zugänglich. Du wirst in Kürze weitergeleitet.',
    billing_data: 'Rechnungsdaten',
    birthday: 'Geburtstag',
    birthdaySelect: 'Datum auswählen',
    block_user_description:
      'Wenn Du fortfährst wird dieser Nutzer von allen Events und Teams, die von Dir verwaltet werden ausgeschlossen. Er wird diese in Zukunft nicht mehr finden und kann ihnen nicht mehr beitreten.',
    block_user_revert_description:
      'Wenn Du fortfährst wird dieser Nutzer von Dir verwaltete Events und Teams wieder finden und ihnen wieder beitreten können.',
    block_user_revert_title:
      'Willst Du diesen Nutzer wirklich nicht weiter blockieren?',
    block_user_revert: 'Nutzer nicht mehr blockieren',
    block_user_title: 'Willst Du diesen Nutzer wirklich blockieren?',
    block_user: 'Nutzer blockieren',
    both: 'Beide',
    brutto_price: 'Bruttopreis (inkl. UsSt.) pro Teilnahme in €',
    brutto_price_recurring:
      'Bruttopreis (inkl. UsSt.) für {{count}} Events in €',
    calendar_permission_settings:
      'SportJoe konnte deinen Kalender aufgrund fehlender Berechtigungen nicht öffnen. Bitte gehe zu den Telefon-Einstellungen und erlaube SportJoe den Zugang zu deinem Kalender.',
    call_disabled_too_early:
      'Du kannst die Video-Übertragung erst 15 Minuten vor dem Event starten',
    CANCEL_EVENT: 'Hat das Event abgebrochen',
    cancel: 'Abbrechen',
    cancelled: 'Abgesagt',
    cancelEvent: 'Stornieren Event',
    cancel_event_dialog_content: 'Dieses Event wird endgültig abgesagt.',
    cancel_event_dialog_title: 'Event absagen',
    cancellation_policy: 'Widerrufsbelehrung',
    cancellation_policy_link: 'Link zur Widerrufsbelehrung',
    change: 'Ändern',
    changeColor: 'Farbe ändern',
    change_email: 'Email ändern',
    change_your_email: 'Ändere deine E-Mail',
    change_your_password: 'Ändere dein Passwort',
    chat: 'Chat',
    chat_loading: 'Chat wird geladen...',
    checkbox_agree_terms:
      'Setze den Haken in der Checkbox, um den App-Nutzungsbedingungen zuzustimmen.',
    city: 'Stadt',
    city_name: 'Stadt',
    choose_company: 'Wähle ein Unternehmen',
    choose_companies: 'Wähle Unternehmen',
    choose_location: 'Bitte wähle einen Ort aus',
    choose: 'Wählen',
    country: 'Land',
    clone: 'Klonen',
    clone_event: 'Event klonen',
    close: 'Schließen',
    company_sports: 'Interessen des Unternehmens',
    club_detail_screen: 'Vereinsinformationen',
    club_join: 'Verein beitreten',
    club_leave: 'Verein verlassen',
    club_list_screen: 'Meine Vereine',
    club_not_found:
      'Der Verein konnte nicht geladen werden. Vielleicht wurde er gelöscht.',
    club_private_description:
      'Dieser Verein kann nur von Teilnehmenden oder denjenigen, mit denen der Verein geteilt wurde, gesehen werden.',
    club_private: 'Privater Verein',
    club_share_message:
      'Hey, ich habe bei SportJoe einen Sport-Verein gefunden, der Dich interessieren könnte: \n\nTitel: {{title}}\nBeschreibung: {{description}}\n\n{{documentUrl}}',
    club_share_title: 'Werde Teil eines SportJoe Vereins',
    club_upcoming_screen: 'Alle Verein-Events',
    club: 'Verein',
    clubs_screen: 'Vereine',
    cockpit_label: 'Cockpit',
    cockpit_title: 'Gesundheitcockpit',
    code_copied: 'Der Zugangscode wurde kopiert',
    cologne: 'Köln',
    COMMENT_EVENT: 'Hat eine Nachricht verfasst',
    comments_screen: 'Nachrichten',
    Comments: 'Chat',
    companies: 'Unternehmen',
    companies_management: 'Unternehmensverwaltung',
    company: 'Unternehmen',
    company_add_failure: 'Fehler beim Erstellen des Unternehmens',
    company_add_success: 'Unternehmen erfolgreich erstellt',
    company_creation_failed: 'Erstellen des Kontos fehlgeschlagen',
    company_creation_failed_support:
      'Erstellen des Kontos fehlgeschlagen. Versuche es noch einmal. Bei Problemen wende Dich an an unseren Support.',
    company_creation_succeeded: 'Rechnungsdaten wurden übermittelt',
    company_deleting_success: 'Unternehmen erfolgreich gelöscht',
    company_deleting_failure: 'Fehler beim Löschen des Unternehmens',
    company_details: 'Unternehmensdetails',
    company_infos: 'Unternehmensinformationen',
    company_infos_edit: 'Daten editieren',
    company_logo: 'Unternehmenslogo',
    company_mail_already_exists:
      'Die Rechnungsdaten mit dieser E-Mail Adresse existieren bereits. Bitte versuche mit einer anderen E-Mail Adresse',
    company_name_already_exists:
      'Die Rechnungsdaten mit diesem Namen existieren bereits. Bitte versuche mit einem anderen Namen',
    company_manager: 'Manager',
    company_role: 'Unternehmensrolle',
    company_update_failure: 'Fehler beim Aktualisieren der Unternehmensdaten',
    company_update_success: 'Unternehmensdaten wurden erfolgreich aktualisiert',
    company_search: 'Firmensuche',
    company_statistics: 'Unternehmensstatistiken',
    complete_onboarding: 'Klicke hier um Verifizierung abzuschließen',
    complete_onboarding_short: 'Verifizierung abschließen',
    confirm: 'Bestätigen',
    confirm_and_continue: 'Bestätigen und weiter',
    confirm_changes: 'Änderungen bestätigen',
    confirmYourMail_description:
      'Bitte denk daran in den nächsten 7 Tagen deine E-Mail zu bestätigen. Schaue dazu auch im Spamordner nach.',
    confirmYourMail_submitButton: 'Verstanden',
    confirmYourMail_title: 'Bestätige deine E-Mail',
    confirm_payment_description:
      'Dieses Angebot ist kostenpflichtig. Der Ersteller dieses Angebots ist für die Preisgestaltung und Durchführung verantwortlich. Der angegebene Preis versteht sich inklusive ges. MwSt.',
    confirm_payment_title: 'Zahlung bestätigen',
    continue: 'Weiter',
    copyEvent: 'Kopie erstellen',
    copy_link: 'Link kopieren',
    create_club: 'Verein anlegen',
    create_event_description_error: 'Die Beschreibung fehlt',
    create_event_location_error: 'Der Ort fehlt',
    create_event_title_error: 'Fehler beim erstellen des Events',
    create_group: 'Team erstellen',
    create_team_or_club: 'Team oder Verein anlegen',
    create: 'Erstellen',
    createJoeEvent: 'Erstelle ein JoeEvent',
    createOwn: 'Erstelle dein eigenes JoeEvent',
    createPassword: 'Gib dein Passwort ein',
    creating_company:
      'Deine Rechnungsdaten werden übermittelt. Dies kann einen Moment dauern. Bitte schließe dieses Fenster nicht.',
    netto_price: 'Nettopreis (exkl. UsSt.) pro Teilnahme in €',
    netto_price_recurring: 'Nettopreis (exkl. UsSt.) für {{count}} Events in €',
    dark_mode: 'Dunkelmodus',
    data_protection: 'Datenschutz',
    date_placeholder: 'Wähle ein Datum',
    date_select: 'Datum wählen',
    date: 'Datum',
    datetime: 'Datum und Uhrzeit',
    days: 'Tage',
    delete_club_dialog_content:
      'Dieser Verein wird zusammen mit all seinen Events und allen Nachrichten endgültig gelöscht.',
    delete_club_dialog_title: 'Verein löschen',
    delete_club: 'Verein löschen',
    delete_company_dialog_content:
      'Dieses Unternehmen wird endgültig gelöscht.',
    delete_company_dialog_title: 'Unternehmen löschen',
    delete_image_dialog_content: 'Möchtest Du dieses Bild wirklich löschen?',
    delete_image_multiple_dialog_content:
      'Möchtest Du die Bilder wirklich löschen?',
    delete_image_title: 'Bild löschen',
    delete_image_multiple_title: 'Bilder löschen',
    delete_message_title: 'Nachricht löschen',
    delete_message_dialog_content:
      'Möchtest Du diese Nachricht wirklich löschen?',
    delete_event_dialog_content:
      'Dieses Event wird zusammen mit allen Nachrichten endgültig gelöscht.',
    delete_event_dialog_content_short: 'Dieses Event wird endgültig gelöscht.',
    delete_event_dialog_title: 'Event löschen',
    DELETE_EVENT: 'Hat das Event abgebrochen',
    delete_group_dialog_content:
      'Dieses Team wird zusammen mit all seinen Events und allen Nachrichten endgültig gelöscht.',
    delete_group_dialog_title: 'Team löschen',
    delete_group: 'Team löschen',

    delete_logo: 'Logo löschen',
    delete_photo: 'Foto Löschen',
    delete_profile_dialog_content: 'Möchtest Du dein Profil wirklich löschen?',
    delete_profile_dialog_title: 'Profil löschen',
    delete_user_avatar: 'Benutzeravatar löschen',
    delete: 'Löschen',
    deleted_user: 'Gelöschter Benutzer',
    description: 'Beschreibung',
    directions: 'Wegbeschreibung',
    direct_chat: 'Direktchat',
    direct_chat_with: 'Direktchat mit {{userName}}',
    direct_to_login: 'Direkt zur Anmeldung gehen',
    dismiss: 'Entlassen',
    distance: 'Entfernung',
    done: 'Fertig',
    download: 'Herunterladen',
    download_app_info_sjone:
      'Lade jetzt unsere one - Active Team App herunter!',
    download_app_info_sportjoe: 'Lade jetzt unsere SportJoe App herunter!',
    download_app_info_part1: 'Klicke ',
    download_app_info_link: 'hier',
    download_app_info_part2_sjone:
      ' um die one - Active Team App herunterzuladen.',
    download_app_info_part2_sportjoe: ' um die SportJoe App herunterzuladen.',
    edit: 'Bearbeiten',
    edit_club_screen: 'Verein bearbeiten',
    edit_club: 'Verein bearbeiten',
    edit_data: 'Daten bearbeiten',
    edit_event_screen: 'Event bearbeiten',
    edit_event: 'Event bearbeiten',
    edit_group_screen: 'Team bearbeiten',
    edit_group: 'Team bearbeiten',
    edit_interests: 'Sportarten bearbeiten',
    edit_modules: 'Module',
    editAccount: 'Nutzerkonto bearbeiten',
    email_placeholder: 'beispiel@email.com',
    email: 'E-Mail',
    email_address: 'E-Mail Adresse',

    empty_interests_screen_txt:
      'Klicke auf das Plus-Icon und wähle alle Sportarten, die Dich interessieren.\n\nWie gut bist Du in deiner Sportart?\nNachdem Du deine Sportarten ausgewählt hast, klicke auf die Sterne, um dein Leistungslevel anzugeben',
    employee: 'Mitarbeiter',
    employee_confirmation_success: 'Mitarbeiter ergolgreich bestätigt',
    employee_confirmation_failure:
      'Bestätigung des Mitarbeiters fehlgeschlagen',
    employee_removing_success: 'Mitarbeiter erfolgreich entfernt',
    employee_removing_failure: 'Mitarbeiter konnte nicht entfernt werden',
    employee_management: 'Mitarbeiterverwaltung',
    employee_role_updating_success: 'Benutzerrolle erfolgreich geändert',
    employee_role_updating_failure:
      'Aktualisierung der Benutzerrolle fehlgeschlagen',
    employee_search: 'Mitarbeitersuche',
    end_date: 'Endtermin',
    end_time: 'Uhrzeit bis',
    english: 'Englisch',
    error_no_loginpermission:
      'Dieser Nutzer hat nicht die benötigten Rechte, um diese App zu nutzen. Vielleicht verfügst Du nicht über die benötigte Benutzerrolle oder Ihre Mitgliedschaft in Ihrem Unternehmen muss noch bestätigt werden?',
    event: 'Event',
    event_cancel: 'Absagen',
    event_cancelled: 'Abgebrochen',
    event_cancelling_success: 'Event wurde erfolgreich abgesagt',
    event_cancelling_failure: 'Fehler beim Absagen des Events',
    event_count: 'Anzahl der Events',
    event_create_failure: 'Fehler beim Erstellen des Events',
    event_create_success: 'Event wurde erfolgreich erstellt',
    event_creating: 'Event wird erstellt',
    event_deleting_success: 'Event wurde erfolgreich gelöscht',
    event_deleting_failure: 'Fehler beim Löschen des Events',
    event_detail_screen: 'JoeEvent',
    event_detail_headline: 'Eventinformationen',
    event_details_less_than_one: 'Weniger als 1',
    event_details: 'Eventdetails',
    event_full: 'Alle Plätze belegt',
    event_in_past: 'JoeEvent liegt in der Vergangenheit',
    event_joining_failure: 'Fehler beim beitreten des Events',
    event_joining_success: 'Du bist dem Event beigetreten',
    event_join: 'Beitreten',
    event_join_paid: 'Beitreten - {{price}}{{currency}}',
    event_leave: 'Verlassen',
    event_leaving_failure: 'Fehler beim Verlassen des Events',
    event_leaving_success: 'Du hast das Event verlassen',
    event_not_found:
      'Laden des Events fehlgeschlagen, weil es vom Administrator entfernt wurde.',
    event_passed: 'Vergangen',
    event_payment_canceled: 'Zahlung abgebrochen',
    event_payment_failed: 'Zahlung fehlgeschlagen',
    event_payment_success: 'Zahlung erfolgreich',
    event_prop_description_placeholder: 'Beschreibung',
    event_prop_description: 'Beschreibung',
    event_prop_title_placeholder: 'Titel',
    event_prop_title: 'Titel',
    event_refund_request_pending: 'Rückerstattungsanfrage gesendet',
    event_search: 'Eventsuche',
    event_share_message_location: 'Ort: {{location}}\n',
    event_share_message_price: 'Preis: {{price}}€\n',
    event_share_message:
      'Hey, ich habe bei SportJoe ein Sport-Treffen gefunden, das Dich interessieren könnte:\n\nTitel: {{title}}\nSportart: {{sport}} {{eventType}}\nDatum: {{dateString}} um {{timeString}} Uhr\n{{location}}Beschreibung: {{description}}\n{{price}}\n\n{{documentUrl}}',
    event_type: 'Event-Art',
    event_update_failure: 'Die Aktualisierung des Events ist fehlgeschlagen',
    event_update_success: 'Das Event wurde erfolgreich aktualisiert',
    event_updating: 'Event wird aktualisiert',
    eventName: 'Name',
    events_screen: 'Events',
    events_search_clicked:
      'Gib ein Stichwort ein, um nach passenden Events zu suchen',
    eventType: 'Meine/Alle Events',
    events: 'Events',
    every: 'jeden',
    everyday: 'Täglich',
    everyDays: 'Alle {{days}} Tage',

    everyone_already_part_off_club:
      'Alle Leute, die Du einladen möchtest, sind bereits Teil des Vereins',
    everyone_already_part_off_team:
      'Alle Leute, die Du einladen möchtest, sind bereits Teil des Teams',
    facebook_sign_in: 'Mit Facebook anmelden',
    feedback_prop_body_placeholder: 'Trage hier dein Feedback ein',
    feedback_prop_body: 'Feedback',
    feedback_prop_subject_placeholder: "Worum geht's? Nenne uns dein Thema",
    feedback_prop_subject: 'Betreff',
    feedback_screen: 'Feedback',
    feedback_send_failure: 'Fehler beim Senden von Feedback',
    feedback_send_success: 'Wir haben dein Feedback erhalten',
    feedback_sending: 'Feedback wird gesendet...',
    feedback: 'Feedback senden',
    fee: 'Plattformgebühr:',
    FEMALE: 'Weiblich',
    file_size_error:
      'Die Datei ist zu groß (maximale Größe ist {{maxSize}} {{unit}}).',
    filterAnyTime: 'Jederzeit',
    filterEvening: '18 - 24 Uhr',
    filterMapPickError:
      'Das Abrufen der Position ist fehlgeschlagen. Wähle eine Position manuell aus',
    filterMorning: '6 - 12 Uhr',
    filterNew: 'Filter',
    filterNextWeek: 'Nächste Woche',
    filterNoon: '12 - 18 Uhr',
    filterPickLocation: 'Suchbereich',
    filterThisWeek: 'Diese Woche',
    filterToday: 'Heute',
    filterTomorrow: 'Morgen',
    findable_description_false:
      'In der öffentlichen Suche werden mir nur Personen angezeigt, die mit mir in einem Verein, Team oder Event sind.',
    findable_description_true:
      'Jeder kann mich in der öffentlichen Suche finden.',
    findable_title: 'Andere Nutzer können mich finden',
    find_us_on: 'Finde uns auf: ',
    for_online_event: 'für Online-Events',
    for_non_online_event: 'für Events die nicht online sind',
    for_recurring_events: 'fur Eventreihe',
    forgot_password_description:
      'Gib deine E-Mail-Adresse an und wir senden Dir eine Nachricht, mir der Du deinen Account wiederherstellen kannst',
    forgot_password_failure:
      'Das Zurücksetzen des Passwortes ist fehlgeschlagen!',
    forgot_password_in_progress: 'Passwort zurücksetzen...',
    forgot_password_navtitle: 'Passwort vergessen',
    forgot_password_request_failure:
      'Fehler beim Anfordern eines neuen Passwortes',
    forgot_password_send: 'Abschicken',
    forgot_password_success:
      'Die Passwort Anfrage wurde an Deine E-Mail Adresse gesendet',
    forgot_password_title: 'Neues Passwort anfordern',
    forgotPassword: 'Passwort vergessen',
    free_events: 'Kostenlose Events',
    full_address: 'Vollständige Adresse',
    fullName: 'Name',
    gender_select: 'Wähle ein Geschlecht',
    gender: 'Geschlecht',
    german: 'Deutsch',
    germany: 'Deutschland',
    go_to_call: 'Starte live Video-Übertragung',
    go_to_event: 'Zum Event',
    google_sign_in: 'Mit Google anmelden',
    group_count: 'Anzahl der Teams',
    group_create_failure: 'Fehler beim Erstellen des Teams',
    group_detail_event_list_events_title: 'Events',
    group_detail_event_list_plus_event: 'Event',
    group_detail_screen: 'Teaminformationen',
    group_details: 'Teamdetails',
    group_join: 'Team beitreten',
    group_joining_failure: 'Fehler beim beitreten des Teams',
    group_joining_success: 'Du bist dem Team beigetreten',
    group_image: 'Teambild',
    group_leave: 'Team verlassen',
    group_leaving_failure: 'Fehler beim Verlassen des Teams',
    group_leaving_success: 'Du hast das Team verlassen',
    group_list_screen: 'Meine Teams',
    group_member: 'Mitglied',
    group_members: 'Mitglieder',
    group_create_success: 'Team wurde erfolgreich erstellt',
    group_deleting_success: 'Team wurde erfolgreich gelöscht',
    group_deleting_failure: 'Fehler beim Löschen des Teams',
    group_not_found:
      'Das Team konnte nicht geladen werden. Vielleicht wurde es gelöscht.',
    group_private_description:
      'Dieses Team kann nur von Teilnehmenden oder denjenigen, mit denen das Team geteilt wurde, gesehen werden.',
    group_private: 'Privates Team',
    group_public: 'Öffentliches Team',
    group_prop_description: 'Beschreibung',
    group_prop_title: 'Titel',
    group_search: 'Teamsuche',
    group_share_message:
      'Hey, ich habe bei SportJoe ein Sport-Team gefunden, das Dich interessieren könnte: \n\nTitel: {{title}}\nBeschreibung: {{description}}\n\n{{documentUrl}}',
    group_share_title: 'Werde Teil eines SportJoe Teams!',
    group_upcoming_screen: 'Alle Team-Events',
    group_update_failure: 'Die Aktualisierung des Teams ist fehlgeschlagen',
    group_update_success: 'Das Team wurde erfolgreich aktualisiert',
    group: 'Team',
    group_photo: 'Teamfoto',
    groups_screen: 'Teams',
    groups: 'Teams',
    heading_error: 'Ups... Etwas ist schiefgelaufen.',
    health_on_demand: 'Gesundheit OnDemand',
    hide_access_codes: 'Zugangscodes ausblenden',
    hide_registration_details:
      'Details zur Registrierung von Mitarbeitern ausblenden',
    history: 'Vergangene Events anzeigen',
    homepage_redirect_message: 'Du wirst zur Startseite umgeleitet.',
    hometown: 'Wohnort',
    hosted_by: 'Erstellt von',
    hosted_for: 'Erstellt für',
    iAgreeWith: 'Ich erkläre mich mit den',
    identifier: 'Indentifikator',
    image_message_text: 'Foto',
    imprint: 'Impressum',
    imprint_link: 'Link zum Impressum',
    interest_advanced: 'Erfahren',
    interest_beginner: 'Anfänger',
    interest_description:
      'Tippe auf eine Sportart, um das Leistungslevel zu ändern',
    interest_newbie: 'Neueinsteiger:in',
    interest_normal: 'Fortgeschritten',
    interest_pro: 'Profi',
    interests_details:
      'Wähle ein bis fünf Sterne, um dein Leistungslevel anzugeben.',
    interests_picker: 'Sportarten',
    interests_saved_failure: 'Fehler beim Speichern deiner Interessen',
    interests_saved_success: 'Deine Interessen wurden erfolgreich gespeichert',
    interests_screen: 'Interessen',
    interest: 'Interesse',
    interests: 'Interessen',
    interestsNotSpecified: 'Keine Sportarten gewählt',
    invitation_sent: 'Deine Einladung wurde gesendet',
    invite_member_club: 'Zum Verein einladen',
    invite_member: 'Zum Team einladen',
    invite: 'Freunde einladen',
    invoicing_details: 'Rechnungsstellungsdetails',
    JOIN_EVENT: 'Ist dem Event beigetreten',
    join: 'Teilnehmen',
    join_event_to_see_chat: 'Tritt dem Event bei, um die Konversation zu sehen',
    join_group_to_see_chat: 'Tritt dem Team bei, um die Konversation zu sehen',
    join_team_to_create_events: 'Tritt dem Team bei, um Events zu erstellen',

    joined: 'Du bist dabei',
    just_now: 'Vor wenigen Sekunden',
    label: 'Label',
    label_company: 'Anzuzeigender Text',
    label_de: 'Deutscher anzuzeigender Text',
    label_en: 'Englischer anzuzeigender Text',
    labelMissing: 'Titel fehlt',
    lbl_description: 'Beschreibung',
    lbl_legalinformation: 'Impressum',
    lbl_loading: 'Wird geladen...',
    lbl_privacypolicy: 'Datenschutz',
    lbl_taptochangecolor: 'Klicken um Farbe zu ändern',
    language: 'Sprache',
    LEAVE_EVENT: 'Hat das Event verlassen',
    legal_screen: 'Rechtliches',
    level_screen: 'Sportarten',
    link_copied: 'Der Link wurde kopiert',
    link_or_contact_with_sj:
      'Verlinkung zu deiner Website oder Kontakt zu SportJoe aufnehmen',
    loading_address: 'Ladeadresse...',
    loading_images: 'Bilder werden geladen',
    loading_image: 'Bild wird geladen',
    loading_medium: 'Medium wird geladen',
    loading_media: 'Medien werden geladen',
    loading_videos: 'Videos werden geladen',
    loading_video: 'Video wird geladen',
    location_add_success: 'Standort erfolgreich erstellt',
    location_add_failure: 'Fehler beim Erstellen des Standortes',
    location_image: 'Standortbild',
    location_management: 'Location-Verwaltung',
    location_name: 'Standortname',
    location_picker_noPermissionMessage:
      'Um deine Position als Standort auszuwählen zu können, brauchen wir deinen aktuellen Aufenthaltsort. Ohne diese Berechtigung musst Du deinen Standort manuell in die Suche eingeben.',
    location_picker_screen: 'Ort wählen',
    location: 'Ort',
    locationForbidden:
      'Du hast SportJoe verboten auf deinen Standort zuzugreifen. Um diese Funktion nutzen zu können, musst Du in deinen Telefoneinstellungen SportJoe erlauben deinen Standort zu bestimmen.',
    login_failure: 'Anmeldung fehlgeschlagen',
    login_success: 'Anmeldung erfolgreich',
    login: 'Anmeldung',
    loginCheckToActivate:
      'Prüfe deine E-Mails, um diesen Account zu aktivieren',
    loginFinalizeLogin:
      'Um die Registrierung abzuschließen benötigen wir noch ein paar Daten',
    loginNoUserWithCredentials: 'Kein Nutzer mit diesen Zugangs-Daten.',
    loginSocialAccount:
      'Das Passwort war falsch. Diese E-Mail ist aber mit einem {{ssoProvider}}-Konto verknüpft. Versuche Dich über {{ssoProvider}} anzumelden oder setze dein Passwort zurück, um Dich nur mit deiner E-Mail Adresse anzumelden.',
    logo_upload: 'Logo hochladen',
    logo_uploaded: 'Logo hochgeladen',
    logout: 'Ausloggen',
    MALE: 'Männlich',
    manage_modules: 'Module verwalten',
    map_filter_screen: 'Suchbereich',
    max_participants: 'Teilnehmerlimit',
    max_file_upload_limit: 'Du kannst maximal {{count}} Bilder hochladen',
    member_count: '{{count}} Teilnehmende',
    member_long: 'Du bist Mitglied dieses Teams',
    members: 'Teilnehmende',
    members_screen_none: 'Noch keine Mitglieder',
    members_screen_plural: '{{count}} Mitglieder:',
    members_screen_singular: '{{count}} Mitglied:',
    message: 'Nachricht',
    min_text_length_error:
      '{{the_field_name}} muss mindestens {{min_length}} Zeichen lang sein',
    minimal_interests_toast: 'Wählen mindestens eine Sportart aus',
    minimumLengthRequired: 'Das Passwort muss mind. 8 Zeichen lang sein',
    missing_label: 'Überall',
    more_comments: 'weitere Nachrichten',
    more_interest: 'Weitere Interessen',
    more_interests: 'Weitere Interessen',
    more: 'Mehr',
    msg_addComment: 'Nachricht erstellen',
    msg_allFieldsRequired: 'Fülle bitte alle Felder aus',
    msg_authFailed: 'Anmeldung fehlgeschlagen. Bitte erneut versuchen!',
    msg_checkMail: 'Bitte prüfe deine E-Mails',
    msg_checkMailforActivation:
      'Bitte prüfe Deine E-Mails zum Aktivieren Deines SportJoe Accounts\nKeine E-Mail? Prüfe Deinen Spam-Ordner',
    msg_checkYourLocation:
      'Checke deinen Standort.\n\nWenn alles passt gibt es gerade kein JoeEvent in deiner Nähe.\n\nKlicke auf die Lupe und ändere die Suchoptionen, oder',
    msg_chooseTitleAndDescription: 'Wähle Titel und Beschreibung',
    msg_connectAccountHint:
      'Es existiert bereits ein Account mit dieser E-Mail. Melde Dich mit dessen Passwort an, um dein {{ssoProvider}}-Konto mit diesem Account zu verknüpfen',
    msg_emailRequired: 'Bitte gib eine gültige E-Mail-Adresse an',
    msg_errorOccurred: 'Es ist ein Fehler aufgetreten',
    msg_fillTheFields: 'Gib zuerst Deine Zugangsdaten ein',
    msg_joined_event: 'Ist dem Event beigetreten',
    msg_left_event: 'Hat das Event verlassen',
    msg_messageSend: 'Nachricht erfolgreich gesendet',
    msg_minFullName: 'Bitte gib mind. 2 Buchstaben ein',
    msg_noEmailMatch:
      'Die eingegebene E-Mail-Adresse kann keinem Konto zugeordnet werden',
    msg_noInternetConnection: 'Keine Verbindung zum Internet',
    msg_noInternetConnectionDescription:
      'Du benötigst eine Internetverbindung, um die App nutzen zu können. Aktuell scheinst Du keine Verbindung zu haben, bitte überprüfe deine Interneteinstellungen und versuche es erneut.',
    msg_pastTime: 'Vergangene Zeit',
    msg_selectFutureTime: 'Bitte wähle die Zeit in der Zukunft aus',
    msg_shareSportjoeMsg:
      'Hey, ich bin schon Teil der SportJoe Community. Probier doch auch die SportJoe App aus, um Sportpartner und Events in deiner Nähe zu finden!\n\nLade die App hier herunter:\n',
    msg_shareSportjoeTitle: 'Ich lade Dich zu SportJoe ein',
    msg_somethingWrong: 'Es ist ein Fehler aufgetreten',
    msg_storeProfileError: 'Bei der Aktualisierung ist ein Fehler aufgetreten',
    msg_updated_event: 'Hat das Event aktualisiert',
    msg_updateSuccessful: 'Aktualisierung war erfolgreich',
    msg_useraccount_banned:
      'Dieser Account wurde von uns wegen Regelverstößen gesperrt',
    msg_youSeeNoEvents: 'Du siehst keine Sport-Veranstaltungen?',
    my_club_list_empty:
      'Du hast noch keinen Verein angelegt. Klicke auf das runde Icon rechts unten und erstelle einen Verein für euch.',
    my_clubs: 'Meine Vereine',
    my_group_list_empty:
      'Du hast noch keinen Verein angelegt. Klicke auf das runde Icon unten rechts, um einen Verein anzulegen.',
    my_all_groups: 'Meine/Alle Teams',
    my_events: 'Meine Events',
    my_past_events: 'Meine vergangenen Events',
    my_teams: 'MeineTeams/Vereine',
    my_groups: 'Meine Teams',
    myEvents: 'Meine Events',
    my_interests: 'Meine Interessen',
    my_stripe_account: 'Mein Stripe Konto',
    module_picture: 'Modulbild',
    modules: 'Gesundheitsmodule',
    modules_set_success: 'Module erfolgreich festgelegt',
    modules_set_failure: 'Fehler beim Festlegen der Module',
    more_options: 'Weitere Optionen',
    NA: 'N/A',
    name_placeholder: 'Dein Name',
    name: 'Name',
    Name: 'Name',
    new_club_screen: 'Neuer Verein',
    new_event: 'Neues Event',
    new_event_screen: 'Neues JoeEvent',
    new_filter: 'Neuer Filter',
    new_group: 'Neues Team',
    new_group_button: 'Neues Team',
    new_group_screen: 'Neues Team',
    new_mail: 'Neue E-Mail',
    new_team_or_club_screen: 'Neuer Verein/Neues Team',
    new_password: 'Passwort ändern',
    newPassword: 'Neues Passwort anfragen',
    next_event: 'Nächstes event',
    no_address_in_invoice_needed: 'Rechnung ohne Adresse wählen',
    no_chats: 'Keine Chats verfügbar',
    no_club: 'Kein Verein',
    no_comments_yet: 'Noch keine Nachrichten',
    no_comments: 'Es gibt noch keine Nachrichten.',
    no_companies_trainer: "You don't have any available companies yet",
    no_events: 'Keine Events',
    no_events_in_area: 'Es gibt keine Events in deiner Nähe.',
    no_group: 'Kein Team',
    no_interests_selected: 'Keine Sportarten gewählt',
    no_modules: 'Du hast keine verfügbaren Gesundheitsmodule',
    no_options: 'Nichts gefunden',
    no_past_events: 'Keine vergangenen Events',
    No_person: 'Niemanden',
    No: 'Nein',
    noCalendarPermission: 'Keine Berechtigung für Zugriff auf Kalender',
    noCameraPermission:
      'Um diese Funktion nutzen zu können benötigen wir Zugriff auf die Kamera. Bitte gewähre uns diese Berechtigung in den Einstellungen der App.',
    noClubs: 'Du siehst keine Vereine?',
    noClubsHint:
      'Checke deinen Standort.\nWenn alles passt gibt es gerade keinen Verein in der Nähe.',
    noEvents: 'Du siehst keine JoeEvents?',
    noEventsFiltered: 'Kein JoeEvent für deine Suchkriterien gefunden',
    noEventsHint:
      'Checke deinen Standort.\nWenn alles passt gibt es gerade kein JoeEvent in der Nähe.',
    noInternet: 'Keine Internetverbindung',
    noLocationEnabled:
      'Um diese Funktion nutzen zu können benötigen wir deinen Standort. Bitte aktiviere deinen Ortungssensor.',
    noLocationPermission:
      'Um diese Funktion nutzen zu können, benötigen wir deinen Standort. Bitte gewähre uns diese Berechtigung in den Einstellungen der App.',
    noLocationsFiltered: 'Keine Orte in Ihren Suchkriterien',
    no_permission: 'Leider kannst Du diese Seite nicht aufrufen.',
    noSportsFiltered:
      'Diese Sportart ist noch nicht in unserer App. \nVersuch´s mal unter "Andere Sportart"',
    noStoragePermission:
      'Um diese Funktion nutzen zu können benötigen wir Zugriff auf den Speicher. Bitte gewähre uns diese Berechtigung in den Einstellungen der App.',
    notifications_request: 'Dürfen wir Dir Push-Benachrichtigungen senden?',
    noTeams: 'Du siehst keine Teams/Vereine?',
    noTeamsHint:
      'Checke deinen Standort.\nWenn alles passt gibt es gerade kein/en Team/Verein in der Nähe.',
    noUpcoming: 'Keine anstehenden Events',
    noUsers: 'Es gibt keine Treffer für deine Suchkriterien',
    noUsersHint: 'Probiere andere Filter aus, um mehr Ergebnisse zu erhalten',
    NTF_AAA_NOTIFICATION_CONSTANTS:
      'following messages are translations for predefined constant messages by server:',
    NTF_CANCEL_EVENT: '{{name}} hat das Event abgebrochen',
    NTF_CLUB_COMMENT: '{{name}} hat eine Nachricht zu dem Verein verfasst',
    NTF_CLUB_CREATED: "Der Verein '{{name}}' ist jetzt bei SportInKöln",
    NTF_CLUB_DELETE: '{{name}} hat den Verein gelöscht',
    NTF_CLUB_JOIN: '{{name}} ist dem Verein beigetreten',
    NTF_CLUB_LEAVE: '{{name}} hat den Verein verlassen',
    NTF_CLUB_UPDATE: '{{name}} hat den Verein aktualisiert',
    NTF_COMMENT_CLUB: '{{name}} hat eine Nachricht zu dem Verein verfasst',
    NTF_COMMENT_EVENT: '{{name}} hat eine Nachricht zu dem Event verfasst',
    NTF_COMMENT_GROUP: '{{name}} hat eine Nachricht in dem Team verfasst',
    NTF_COMMENT_TITLE: 'Neue Nachricht',
    NTF_COMMENT: '{{name}} hat eine neue Nachricht verfasst',
    NTF_DELETE_CLUB: '{{name}} hat den Verein gelöscht',
    NTF_DELETE_EVENT: '{{name}} hat das Event gelöscht:',
    NTF_DELETE_GROUP: '{{name}} hat das Team gelöscht',
    NTF_EVENT_CANCEL: '{{name}} hat das Event abgebrochen',
    NTF_EVENT_COMMENT: '{{name}} hat eine Nachricht zu dem Event verfasst',
    NTF_EVENT_CREATED: "Das Event '{{name}}' wurde erstellt",
    NTF_EVENT_DELETE: '{{name}} hat das Event gelöscht:',
    NTF_EVENT_JOIN: '{{name}} ist dem Event beigetreten',
    NTF_EVENT_LEAVE: '{{name}} hat das Event verlassen',
    NTF_EVENT_UPDATE: '{{name}} hat das Event aktualisiert',
    NTF_GROUP_COMMENT: '{{name}} hat eine Nachricht in dem Team verfasst',
    NTF_GROUP_CREATED: "Das Team '{{name}}' wurde erstellt",
    NTF_GROUP_DELETE: '{{name}} hat das Team gelöscht',
    NTF_GROUP_JOIN: '{{name}} ist dem Team beigetreten',
    NTF_GROUP_LEAVE: '{{name}} hat das Team verlassen',
    NTF_GROUP_UPDATE: '{{name}} hat das Team aktualisiert',
    NTF_JOIN_CLUB: '{{name}} ist dem Verein beigetreten',
    NTF_JOIN_EVENT: '{{name}} ist dem Event beigetreten',
    NTF_JOIN_GROUP: '{{name}} ist dem Team beigetreten',
    NTF_LEAVE_CLUB: '{{name}} hat den Verein verlassen',
    NTF_LEAVE_EVENT: '{{name}} hat das Event verlassen',
    NTF_LEAVE_GROUP: '{{name}} hat das Team verlassen',
    NTF_MESSAGE_DELETED: 'Diese Nachricht wurde gelöscht',
    NTF_UPDATE_CLUB: '{{name}} hat den Verein aktualisiert',
    NTF_UPDATE_EVENT: '{{name}} hat das Event aktualisiert',
    NTF_UPDATE_GROUP: '{{name}} hat das Team aktualisiert',
    numberRangeFilter_maxLowerThanMin:
      'Der erste Wert muss kleiner als der zweite sein.',
    numberRangeFilter_notAnInt:
      'Gratulation, Du hast einen Fehler in SportJoe gefunden! Es ist toll, dass Du es irgendwie geschafft hast hier etwas rein zu schreiben, was keine ganze Zahl ist, aber verarbeiten können wir es leider auch nicht. Weil wir SportJoe immer weiter verbessern wollen, wäre es toll, wenn Du uns melden könntest, wie Du es geschafft hast diesen Fehler auszulösen. Diesen und andere Fehler kannst Du uns ganz einfach unter {{profile_screen}}→{{feedback}} mitteilen.',
    numberRangeFilter_valueGreaterThanMax:
      'Es sind nur Werte bis {{maxValue}} erlaubt.',
    numberRangeFilter_valueLowerThanMin:
      'Es sind nur Werte ab {{minValue}} erlaubt.',
    offline: 'Offline',
    of_company: 'von {{companyName}}',
    of_provider: 'des Anbieters',
    ofSportJoe: 'von SportJoe einverstanden',
    on_demand: 'On Demand',
    on_demand_link: 'Der Link zum On-Demand Event',
    one_description:
      'Sportmöglichkeiten und Gesundheitsvorsorge für Trainer und Organisationen',
    one_week_ago: 'Vor einer Woche',
    online_event_description:
      'Biete dein Event auch Online über den Live-Video-Chat an. Bei Aktivierung wird ein Link für das Online-Event in den Eventdetails angezeigt.',
    online_event: 'Online Event',
    online: 'Online',
    online_and_offline: 'Online & Offline',
    online_big: 'Online',
    online_upper: 'ONLINE EVENT',
    only_clubs: 'nur Vereine',
    only_teams: 'nur Teams',
    open_chats: 'Öffne Chats',
    open_company: 'Öffne Unternehmen',
    open_event: 'Öffne Event',
    open_group: 'Öffne Team',
    open_settings: 'Öffne Einstellungen',
    open_user_settings: 'Öffne Benutzereinstellungen',
    optimal_dimensions:
      'Optimale Abmessungen: {{width}}:{{height}} (Breite x Höhe)',
    optional: 'Optional',
    options: 'Einstellungen',
    or: 'oder',
    order_summary: 'Zusammenfassung Deiner Bestellung',
    OTHER: 'Divers',
    our: 'In unserem',
    owner_imprint: 'Impressum von',
    paid: 'Kostenpflichtig',
    paid_event: 'Kostenpflichtiges Event',
    paid_events: 'Kostenpflichtige Events',
    paid_offers:
      'Denk bei einem kostenpflichtigen Angebot daran, deine Pflichtangaben (z.B. nach § 5a Abs. 3 UWG und §5 TMG) zu ergänzen. Schreibe bitte vor den Anfang deines Texts das Wort [Anzeige] oder [Werbung]',
    page_not_available: 'Seite nicht verfügbar',
    participant_detail_screen: 'Teilnehmer:in',
    participant_details_title: 'Teilnehmer:innendetails',
    participants_number: 'Anzahl der Teilnehmenden',
    participants_screen: 'Alle Teilnehmenden',
    participants_screen_none: 'Noch keine Teilnehmenden',
    participants_screen_singular: '{{count}} Teilnehmer:in:',
    participants_screen_plural: '{{count}} Teilnehmende:',
    participants_screen_plural_with_limit:
      '{{count}} von {{limit}} Teilnehmenden:',
    participating: 'Du nimmst teil!',
    participating_long: 'Du nimmst am Event teil!',
    partners: 'Unsere Partner',
    passedEvents: 'Vergangene Events',
    password_placeholder: '********',
    password: 'Passwort',
    past_event: 'Vergangen',
    pay_and_order: 'Zahlungspflichtig bestellen',
    pay_now: '{{price}} Jetzt zahlungspflichtig bestellen',
    payment_type: 'Bezahlung',
    payout_per_participant: 'Auszahlungsbetrag an Dich (brutto)',
    pending_invite: 'Du wurdest zu diesem Raum eingeladen',
    pending_knock: 'You asked to be invited to join this room',
    people_going: 'Teilnehmer:in',
    peopleInterestedIn: 'Wenn Du Interesse hast an',
    permission_calendar_message:
      'Um den Termin eines JoeEvents in deinen Kalender zu übertragen brauchen wir die Berechtigung auf deinen Kalender zuzugreifen.',
    permission_calendar_title:
      'Warum benötigen wir Zugriff auf deinen Kalender?',
    permission_camera_message:
      'Mit der Kamera kannst Du ein individuelles Foto aufnehmen und anzeigen.',
    permission_camera_title: 'Wofür benötigen wir die Kamera?',
    permission_location_message:
      'Um Dir JoeEvents in deiner Nähe anzeigen zu können, brauchen wir deinen aktuellen Aufenthaltsort. Ohne diese Berechtigung funktioniert die Suche nach JoeEvents nicht.',
    permission_location_title: 'Warum benötigen wir die Ortung?',
    permission_microphone_message:
      'Wir möchten deine Stimme während des Videoanrufs übertragen.',
    permission_microphone_title:
      'Die SportJoe-App möchte auf Dein Mikrofon zugreifen',
    permission_storage_message:
      'Wenn wir auf deine gespeicherten Medien zugreifen dürfen, kannst Du Bilder aus deiner Galerie auswählen.',
    permission_storage_title: 'Warum brauchen wir die Erlaubnis zum Speichern?',
    pick_time: 'Uhrzeit wählen',
    picker_screen: 'Wähle deine Sportarten',
    pickTime: 'Uhrzeit wählen',
    phoneNumber: 'Telefonnummer',
    photo_uploaded: 'Foto hochgeladen',
    postal_code: 'Postleitzahl',
    plus_more_count: ' (+{{count}} mehr)',
    price: 'Preis',
    privacy_policy: 'Datenschutzhinweis',
    privacy_screen: 'Privatsphäre',
    privacy: 'Privatsphäre',
    private_description:
      'Dieses Event kann nur von Dir und Leuten gesehen werden, denen Du eine Einladung schickst.',
    private_title: 'Privates Event',
    private: 'Privat',
    proceed_to_payment: 'Weiter zur Zahlung',
    profile_choose_image: 'Foto auswählen',
    profile_delete_account: 'Möchtest Du wirklich dein Profil Löschen?',
    profile_delete_image: 'Bild löschen und Initialen verwenden',
    profile_screen: 'Profil',
    profile_take_image: 'Foto machen',
    profile_update_failure: 'Fehler beim Update deines Profils',
    profile_update_success: 'Profil erfolgreich aktualisiert',
    profile_updating: 'Dein Profil wird aktualisiert...',
    prop_user_color_placeholder: 'Suche Dir eine Farbe aus, die zu Dir passt',
    prop_user_color: 'Nutzerfarbe',
    prop_user_description_placeholder: 'Stelle Dich kurz vor',
    prop_user_description: 'Beschreibung',
    prop_user_gender_placeholder: 'Gib dein Geschlecht an',
    prop_user_gender: 'Geschlecht',
    prop_user_name_placeholder: 'Gib dein Alias ein',
    prop_user_name: 'Name',
    public_clubs: 'Öffentliche Vereine',
    public_event: 'Öffentliches Event',
    public_groups: 'Öffentliche Teams',
    quote: 'Zitieren',
    recurring_description:
      'Ist diese Option gewählt, handelt es sich um ein wöchentlich zur selben Uhrzeit wiederholendes Event.',
    recurring_end_before_start_error:
      'Der Endtermin muss nach dem Startdatum liegen',
    recurring_title: 'Wiederkehrendes Event',
    recurring_weekly: 'Wöchentich',
    recurring_weekly_short: 'Wöch.',
    recurring: 'Wiederkehrend',
    register_failure_email_used: 'Die E-Mail Adresse ist bereits registriert',
    register_failure: 'Registrierung fehlgeschlagen',
    register_in_progress: 'Registrierung läuft...',
    register: 'Registrieren',
    registration_details: 'Registrierungsdetails',
    registration_link: 'Registrierungslink',
    reject_invite: 'Einladung ablehnen',
    reload_events: 'Events neu laden',
    reload_groups: 'Teams neu laden',
    reminder_description_hometown:
      'Trage jetzt deinen Wohnort ein. Sportbegeisterte Menschen, die in deiner Nähe wohnen, können Dich so leichter finden.',
    reminder_description_sports:
      'Trage jetzt deine Lieblingssportarten ein. Menschen, die deine Leidenschaft teilen, können Dich so leichter finden.',
    reminder_later: 'Später',
    reminder_never: 'Nicht mehr erinnern',
    reminder_now: 'Jetzt Eintragen',
    reminder_title: 'Dein Profil ist noch unvollständig',
    remove_club: 'Verein entfernen',
    remove_employee: 'Mitarbeiter entfernen',
    remove_employee_dialog_title: 'Mitarbeiter Enfernen',
    remove_employee_dialog_content:
      'Dieser Mitarbeiter wird aus dem Unternehmen entfernt.',
    remove_event: 'Event löschen',
    remove_group: 'Team entfernen',
    request_refund: 'Rückerstattung anfragen',
    request_refund_description:
      'Wenn Du bestätigst, senden wir eine Rückerstattungsanfrage an den Veranstalter. Ob Du das Geld erhältst, hängt jedoch davon ab, ob Du die Rückerstattungsfrist des Veranstalters eingehalten hast.',
    request_refund_message:
      'Hallo, ich wollte um Rückerstattung für das Event {{eventName}} bitten. {{name}}, {{email}}.',
    report_club_screen: 'Verein melden',
    report_club: 'Verein melden',
    report_event_screen: 'Event melden',
    report_event: 'Event melden',
    report_prop_body_placeholder:
      'Gib hier an, warum Du {{the_reportedObjectType}} melden möchtest',
    report_prop_body_user: 'Was hat {{reportedObject}} falsch gemacht?',
    report_prop_body: 'Was ist in {{reportedObject}} falsch gelaufen?',
    report_send_failure: 'Deine Nachricht konnte nicht gesendet werden',
    report_send_success: '{{reportedObjectName}} wurde gemeldet',
    report_team_screen: 'Team melden',
    report_team: 'Team melden',
    report_user_screen: 'Benutzer melden',
    report_user: 'Benutzer melden',
    reset: 'reset',
    reset_filter: 'Filter zurücksetzen',
    resilience: 'Resilienz',
    return_to_homepage: 'Zurück zur Homeseite',
    role_change_confirmation_text:
      'Soll die Benutzerrolle auf {{role}} geändert werden?',
    role_change_confirmation_title: 'Änderungen bestätigen',
    screen_back: 'Zurück',
    safari_matrix_info:
      'Der Chat ist in Safari derzeit nicht verfügbar. Bitte wechsle zu einem anderen Browser, um fortzufahren.',
    saw_all_events:
      'Du hast alle Events gesehen. Versuche, deine Filterkriterien zu ändern, um weitere Events zu finden.',
    saw_all_events_on_demand:
      'Du hast alle On-Demand Events gesehen. Versuche, deine Filterkriterien zu ändern, um weitere On-Demand Events zu finden.',
    saw_all_groups:
      'Du hast alle Teams gesehen. Versuche, deine Filterkriterien zu ändern, um weitere Teams zu finden.',
    save: 'Speichern',
    search_area: 'Suchbereich',
    search_area_km: 'Suchbereich in Kilometer',
    search_events: 'Eventsuche',
    search_teams: 'Teamsuche',
    search_user: 'Benutzer suchen',
    search: 'Suchen',
    searchSports: 'Suche nach Sportart',
    see_all_comments: 'Alle Nachrichten anzeigen',
    see_all_events: 'Alle Events anzeigen',
    see_all: 'Alle anzeigen',
    see_club_details: 'Gehe zum Verein',
    see_group_details: 'Gehe zum Team',
    see_more: 'Mehr anzeigen',
    see_on_the_map: 'Auf der Karte ansehen',
    select_club: 'Wähle einen Verein',
    select_group: 'Wähle ein Team',
    select_location: 'Ort wählen',
    send: 'Senden',
    sendingFeedback: 'Dein Feedback wird gesendet...',
    settings: 'Einstellungen',
    share_club: 'Verein teilen',
    share_group: 'Team teilen',
    share: 'Event Teilen',
    share_message: 'Gerade bei #{{appVariant}} gefunden. Wie findest Du das?',
    share_message_with_url:
      'Gerade bei #{{appVariant}} gefunden. Wie findest Du das?\n\n{{url}}',
    share_sj: 'SportJoe Event',
    share_with: 'Teilen mit {{platform}}',
    show_access_codes: 'Zugangscodes anzeigen',
    show_registration_details:
      'Details zur Registrierung von Mitarbeitern anzeigen',
    show_more_interests: 'Mehr',
    show_all_events: 'Zeige alle Events',
    show_all_groups: 'Zeige alle Teams',
    show_company_events: 'Zeige Unternehmensevents',
    show_company_groups: 'Zeige Unternehmensteams',
    showList: 'Liste anzeigen',
    showMap: 'Karte anzeigen',
    show_default_photo: 'Standardfoto anzeigen',
    showTermsRequiredHint: 'Pflichtfeld',
    signIn: 'Sign In',
    signUp: 'Registrieren',
    socialSignUp: 'Letzter Schritt',
    sport_select: 'Sport wählen',
    sport: 'Sport',
    sport_discipline: 'Sportart',
    sports_community: 'Deine Sportcommunity',
    sports_picker_screen: 'Sport-Auswahl',
    sports_selected_count: '{{count}} Sportarten ausgewählt',
    spouse: 'Ehepartner',
    start_time: 'Uhrzeit ab',
    street: 'Straße',
    street_number: 'Straßennummer',
    stripe_account_no_company:
      'Bitte teile uns die Daten für das Stellen von Rechnungen mit, um kostenpflichtige Events erstellen zu können.',
    stripe_account_not_verified:
      'Dein Stripe-Konto ist nicht verifiziert. Bitte verifiziere dein Konto, um kostenpflichtige Events erstellen zu können.',
    stripe_account_not_verified_no_company:
      'Dein Stripe-Konto ist nicht verifiziert. Bitte verifiziere dein Konto, und teile uns die Daten für das Stellen von Rechnungen mit, um kostenpflichtige Events erstellen zu können.',
    stripe_fee_info: 'Zahlungsdienstleister: Ab 1,5% + € 0,25',
    stripe_onboarding_app_tag_info:
      'Wenn Du ein kostenpflichtiges Event erstellen möchtest, besuche gerne unsere Webseite ',
    stripe_onboarding_info:
      'Dein Stripe-Konto wird eingerichtet. Du wirst gleich weitergeleitet.',
    subject: 'Titel',
    subscription_choice: 'Ausgabe-Auswahl',
    subscription_mh:
      "Ich möchte zwei kostenlose Men's Health Ausgaben erhalten",
    subscription_no: 'Ich möchte keine kostenlosen Ausgaben erhalten',
    subscription_wh:
      "Ich möchte zwei kostenlose Women's Health Ausgaben erhalten",
    submit: 'Abschicken',
    submit_payment: '{{price}}€ zahlen',
    supported_payment_methods: 'Unterstützte Zahlungsmethoden:',
    team_choose_image: 'Bild auswählen',
    team_delete_image: 'Bild löschen',
    teams: 'Teams',
    teams_and_clubs_screen: 'Vereine & Teams',
    teams_type: 'Vereine oder Teams',
    telsYou: 'erfährst Du, warum und wofür wir deine Daten benötigen.',
    terms_and_conditions: 'Allgemeine Geschäftsbedingungen',
    terms_and_conditions_sj: 'AGB Sportjoe GmbH',
    terms_of_participation: 'Teilnahmebedingungen',
    terms_of_use: 'Nutzungsbedingungen',
    the_cancellation_policy: 'die Widerrufsbelehrung',
    the_terms_of_use: 'die Nutzungsbedingungen',
    the_terms_of_participation: 'die Teilnahmebedingungen',
    terms_of_participation_link: 'Link zu Deinen Teilnahmebedingungen',
    thanksForFeedback: 'Danke für dein Feedback',
    the_club: 'der Verein',
    the_event: 'das Event',
    the_interests_levels: 'Leistungslevel',
    the_interests: 'Sportarten',
    the_login: 'Anmeldung',
    the_subject: 'Der Betreff',
    the_team: 'das Team',
    the_title: 'Der Titel',
    the_user: 'den Nutzer',
    time_from_miniscule: 'ab',
    time_from: 'Ab',
    time_oClock: 'Uhr',
    time_placeholder: 'Wähle eine Uhrzeit',
    time_select: 'Tippen um Zeit zu wählen',
    time_upTo: 'Bis',
    time: 'Uhrzeit',
    title: 'Titel',
    title_Add_members_club: 'Zum Verein einladen',
    title_Add_members_group: 'Zum Team einladen',
    today: 'Heute',
    to_connectAndLogin: 'Verbinden und Anmelden',
    to_filter: '{{documentType}} filtern',
    to_login: 'Anmelden',
    to_requestConfirmationEmail: 'Neue Bestätigungs-E-Mail senden',
    to_select: 'Auswählen',
    trainer: 'Trainer',
    trainer_event: 'Trainer Event',
    trainer_group: 'Trainer Team',
    trainer_welcome_text:
      'Liebe/r Trainer/in,\n\nauf dieser Plattform kannst Du Angebote rund um das Thema Gesundheitsprävention erstellen. Nur Beschäftigte der Unternehmen, die Dich zur Registrierung eingeladen haben, können an Deinen Angeboten teilnehmen. Orts- und zeitgebundene Termine erstellst Du im Reiter „Events“. Über den Reiter „Teams“ fügst Du Gruppen hinzu, um mit interessierten Teilnehmer/innen in Kontakt zu treten. Über den Reiter „Chats“ siehst Du alle Gruppen- und Einzelchats im Überblick.\n\nViel Spaß bei der Nutzung von one - Active Team!',
    unblock_user: 'Nicht mehr blockieren',
    understood: 'Verstanden',
    unlimited: 'Unbegrenzt',
    until: 'bis',
    unread_event: '{{count}} ungelesene Nachricht',
    unread_events: '{{count}} ungelesene Nachrichten',
    unread_events_count: 'Neue Chat-Nachrichten',
    upcoming_events_screen: 'Meine Events',
    UPDATE_EVENT: 'Hat das Event aktualisiert',
    update_company_data: 'Unternehmensdaten bearbeiten',
    update_event: 'Event bearbeiten',
    update_group: 'Team bearbeiten',
    update_interests: 'Interessen bearbeiten',
    update_user_data: 'Benutzerdaten bearbeiten',
    update: 'Aktualisieren',
    updateClub: 'Verein aktualisieren',
    upload_logo: 'Logo hochladen',
    updateGroup: 'Team aktualisieren',
    updateProfile: 'Profil aktualisieren',
    upload_media: 'Medien hochladen',
    upload_photo: 'Foto hochladen',
    upload_user_avatar: 'Benutzeravatar hochladen',
    url: 'URL',
    use19vat:
      'Fällt auf die von Dir organisierten Events die 19% Mehrwertsteuer an?',
    use19vat_info: 'Information über Mehrwertsteuer',
    user_avatar: 'Benutzeravatar',
    user_blocked: 'Benutzer is blockiert',
    user_deleted: 'Nutzer wurde gelöscht',
    user_interests_not_selected:
      'Der Nutzer hat noch keine Interessen ausgewählt',
    user_no_interests:
      'Der Nutzer hat noch keine favorisierten Sportarten gewählt.',
    user: 'SportJoe User',
    user_confirmed: 'Bestätigt',
    user_count: 'Anzahl der Nutzer',
    userName: 'Benutzername',
    user_owns_paid_events:
      'Du hast kostenpflichtige Events erstellt, die noch nicht stattgefunden haben. Das Löschen deines Profils ist deshalb unmöglich.',
    user_role: 'Benutzerrolle',
    user_informations: 'Benutzerinformationen',
    user_infos_update_success:
      'Benutzerinformationen wurden erfolgreich aktualisiert',
    user_infos_update_failure:
      'Aktualisierung der Benutzerinformationen fehlgeschlagen',
    user_not_authenticated: 'Du bist nicht authentifiziert',
    user_profile: 'Benutzerprofil',
    user_settings: 'Benutzereinstellungen',
    validation_allrequired: 'Bitte fülle alle Felder aus',
    validation_birthdate_minimumAge: 'Das Mindestalter beträgt {{minimumAge}}',
    validation_invalid: 'Ungültiger Wert für {{fieldName}}',
    validation_required: '{{fieldName}} ist ein Pflichtfeld',
    validation_title_less_2: 'Der Titel muss wenigstens 2 Zeichen lang sein.',
    video_message_text: 'Video',
    wait_progress: 'Bitte warten...',
    website: 'Webseite',
    weekday_notSelectedError: 'Wähle mind. einen Wochentag aus',
    weekdayAll: 'Alle Tage',
    weekdayFriday_short: 'Fr',
    weekdayFriday: 'Freitags',
    weekdayMonday_short: 'Mo',
    weekdayMonday: 'Montags',
    weekdaySaturday_short: 'Sa',
    weekdaySaturday: 'Samstags',
    weekdaySunday_short: 'So',
    weekdaySunday: 'Sonntags',
    weekdayThursday_short: 'Do',
    weekdayThursday: 'Donnerstags',
    weekdayTuesday_short: 'Di',
    weekdayTuesday: 'Dienstags',
    weekdayWednesday_short: 'Mi',
    weekdayWednesday: 'Mittwochs',
    weekdays: 'Wochentage',
    whereAreYouLooking: 'Hier suchen',
    welcome: 'Willkommen',
    welcome_text: 'Willkommenstext',
    writeComment: 'Schreib eine Nachricht',
    writeFeedback: 'Schreib Dein Feedback hier',
    writeSubject: 'Betreff',
    wrong_credentials: 'Falsche Zugangsdaten',
    year_abbr: 'J',
    yearOfBirth: 'Geburtsjahr',
    Yes: 'Ja',
    yesterday: 'Gestern',
    you: 'Du',
    your_companies: 'Deine Unternehmen:',
    your_full_name: 'Dein vollständiger Name',
    your_logo: 'Dein Unternehmenslogo',
    your_name: 'Dein Name',
    your_password: 'Dein Passwort',
    your_position: 'Deine Position',
    yourProfileForOthers_description:
      'Suche und finde neue Sportpartner, Vereine und Sportevents. Du entscheidest, was andere über Dich sehen.',
    yourProfileForOthers_title: 'Dein Profil für andere'
  },
  navigation: {},
  example: {
    card_title: 'Ein Titel',
    card_subtitle: 'Ein Untertitel',
    card_text: 'Das hier ist ein Text in einer Card Komponente',
    card_input_title: 'Einige Input Elemente',
    input_text: 'Text Input',
    input_search_placeholder: 'Suche'
  },
  validation: {
    address_invalid: 'Bitte wähle eine gültige Adresse aus.',
    date_in_past: 'Das gewählte Datum darf nicht in der Vergangenheit liegen.',
    end_date_cannot_be_before_start_date:
      'Das Enddatum kann nicht vor dem Startdatum liegen.',
    end_time_cannot_be_before_start_time:
      'Die Endzeit darf nicht vor der Startzeit liegen.',
    end_date_must_be_after_start_date:
      'Das Enddatum muss mindestens {{days}} Tage nach dem Startdatum liegen',
    email_invalid: 'Bitte gib eine gültige Adresse ein.',
    phone_invalid: 'Bitte gib eine gültige Telefonnummer ein.',
    website_invalid:
      'Bitte gib eine gültige Webseite ein die mit "https" beginnt.',
    url_invalid: 'Bitte gib eine gültige URL ein, die mit "https" beginnt.',
    is_required: '{{name}} ist erforderlich.',
    max_length: '{{name}} darf nicht mehr als {{max}} Zeichen lang sein.',
    min_length: '{{name}} muss mindestens {{min}} Zeichen lang sein.',
    min_value: '{{name}} muss mindestens {{min}} betragen.',
    min_age: 'Der Benutzer muss mindestens {{age}} Jahre alt sein.',
    max_age: 'Der Benutzer darf höchstens {{age}} Jahre alt sein.',
    invalid_participants:
      'Die maximale Anzahl von Teilnehmern muss eine Zahl oder "unbegrenzt" sein.',
    less_than_current:
      'Die maximale Teilnehmerzahl darf nicht kleiner sein als die aktuelle Teilnehmerzahl.',
    cancellation_policy_must_be_accepted:
      'Die Widerrufsbelehrung muss akzeptiert werden',
    terms_of_participation_must_be_accepted:
      'Die Teilnahmenbedingungen müssen akzeptiert werden',
    terms_of_use_must_be_accepted:
      'Die Nutzungsbedingungen müssen akzeptiert werden',
    time_in_past: 'Die gewählte Zeit darf nicht in der Vergangenheit liegen.',
    weekday_notSelectedError: 'Wähle mind. einen Wochentag aus'
  },

  system_messages: {
    room_joined: '{{user}} ist dem Raum beigetreten',
    room_left: '{{user}} hat den Raum verlassen',
    room_created: 'Raum erstellt',
    event_cancelled: '{{user}} hat das Event abgesagt',
    event_edited: '{{user}} hat das Event bearbeitet',
    group_edited: '{{user}} hat das Team bearbeitet',
    knocked: 'Warte auf Einladung',
    invited: 'Eingeladen',
    member_invited: '{{user}} wurde eingeladen',
    namechange: "{{oldName}} ändert den Namen zu '{{newName}}'",
    invite_rejected: '{{user}} hat die Einladung abgelehnt',
    room_metadata: 'Admin hat Raumdaten bearbeitet',
    redacted: 'Nachricht wurde gelöscht'
  },

  health_modules: {
    open_module: 'Öffne Modul',
    module: {
      covital: 'CoVital',
      entspannung: 'Entspannung',
      ernaehrung: 'Ernährung',
      konsum: 'Konsum',
      medialib: 'Mediathek',
      schlaf: 'Schlaf',
      sport_und_bewegung: 'Sport und Bewegung',
      ['entspannung-test']: 'Entspannung',
      ['ernaehrung-test']: 'Ernährung',
      ['konsum-test']: 'Konsum',
      ['medialib-test']: 'Mediathek',
      ['schlaf-test']: 'Schlaf',
      ['sport_und_bewegung-test']: 'Sport und Bewegung'
    },
    cockpit_home: 'Gesundheitscockpit',
    complete_survey_message:
      'Es ist notwendig, dass Du vor benutzen dieses Moduls einen Fragebogen ausfüllst.',
    complete_survey_goto: 'Zum Fragebogen',
    complete_survey_cancel: 'Zurück',
    complete_survey_sleep_message:
      'Wir möchten Dich bitten den Fragebogen zum Thema Schlaf zu beantworten.',
    complete_survey_sleep_goto: 'Fragebogen abschließen'
  }
};
